// extracted by mini-css-extract-plugin
module.exports = {"content":"LocationPage_content__1qqe1"};